"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
var _default = {
  name: "organizationUserSystemConfig:view",
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['excelFormatOption']), {
    errorInfo: function errorInfo() {
      return {
        emptyFormat: this.$t('organizationUserSettings.excelFormatText') + this.$t('SMS.canNotBeEmpty'),
        emptyRowLimit: this.$t('organizationUserSettings.rowLimitText') + this.$t('SMS.canNotBeEmpty'),
        invalidRowLimit: this.$t('warningMessage.invalidRowLimitMessage')
      };
    },
    rules: function rules() {
      var _this = this;

      var isEmpty = function isEmpty(obj) {
        return typeof obj == 'undefined' || obj == null || obj === '' || obj.length === 0;
      };

      var rowLimit = function rowLimit(rule, value, callback) {
        if (isEmpty(value)) {
          return callback(new Error(_this.errorInfo.emptyRowLimit));
        }

        if (!(_this.excelSettings.format == 'xls' || _this.excelSettings.format == 'xlsx')) {
          return callback(new Error(_this.errorInfo.emptyFormat));
        }

        if (_this.excelSettings.format == 'xls') {
          if (parseInt(value) > 65536) {
            return callback(new Error(_this.errorInfo.invalidRowLimit));
          } else {
            return callback();
          }
        }

        if (_this.excelSettings.format == 'xlsx') {
          if (parseInt(value) > 1048576) {
            return callback(new Error(_this.errorInfo.invalidRowLimit));
          } else {
            return callback();
          }
        }
      };

      return {
        rowLimit: [{
          required: true,
          validator: rowLimit,
          trigger: 'blur'
        }],
        format: [{
          required: true,
          trigger: 'blur'
        }]
      };
    }
  }),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      excelSettings: {
        format: '',
        rowLimit: ''
      },
      currentSettingMessage: ""
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.excelSettings = {
        format: 'xlsx',
        rowLimit: 500000
      };
      this.getCurrentSetting();
    },
    getCurrentSetting: function getCurrentSetting() {
      var _this2 = this;

      _httpUtils.default.post("organizationUser", "getExcelSetting", null, null).then(function (res) {
        if (res.code === 200 && res.data != undefined && res.data != "" && res.data != "null") {
          _this2.currentSettingMessage = res.data;
        } else {
          _this2.currentSettingMessage = _lang.default.t('warningMessage.defaultExcelSettingMessage');
        }
      });
    },
    handleReset: function handleReset() {
      this.init();
      this.$refs["dataForm"].clearValidate();
    },
    handleAdd: function handleAdd() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var param = _this3.excelSettings;

          _httpUtils.default.post("organizationUser", "addExcelSetting", null, param).then(function (res) {
            if (res.code === 200) {
              _this3.$notify({
                title: _lang.default.t('warningMessage.addExcelSettingSuccessMessage'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              _this3.$refs["dataForm"].clearValidate();
            }

            if (res.code === 500) {
              _this3.$notify({
                title: _lang.default.t('warningMessage.addExcelSettingFailMessage'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this3.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    }
  }
};
exports.default = _default;